import React from 'react';
import ListSpinner from './ListSpinner';
import MobileCardList from './MobileCardList';

/**
 * Affiche des mini-cards sur mobile et un tableau sur desktop (md+).
 */
const ResponsiveDataList = ({
  isLoading,
  isEmpty,
  emptyMessage = 'Aucun élément',
  mobileCards,
  children,
}) => {
  if (isLoading) {
    return <ListSpinner />;
  }

  return (
    <>
      <MobileCardList
        className="md:hidden"
        isEmpty={isEmpty}
        emptyMessage={emptyMessage}
      >
        {mobileCards}
      </MobileCardList>

      <div className="hidden md:block bg-white shadow rounded-lg overflow-x-auto">
        {children}
      </div>
    </>
  );
};

export default ResponsiveDataList;
